'use client';

import React from 'react';
import { Typography } from '../../../../components';
import { useTranslations } from '../../../../contexts/translation.context';
import { EarnData } from '../types';

interface EarningsCellProps {
  data: EarnData;
}

const EarningsCell: React.FC<EarningsCellProps> = ({ data }) => {
  const { t } = useTranslations();

  const income = Number(data.total_amount) || 0;
  const costs = 0; // Placeholder - would come from costs API
  const profit = income - costs;
  const totalAmount = income; // Placeholder for total amount before marketer's commission

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-1">
        <Typography variant="body3" className="text-auth-muted">
          {t('partner.revshare.income.table.incomeLabel')}:
        </Typography>
        <Typography variant="body3" className="text-dark font-medium">
          ${income.toFixed(2)}
        </Typography>
        {/* <Typography variant="body3" className="text-neutral-500">
          ({t('partner.revshare.income.table.total')}:${totalAmount.toFixed(2)})
        </Typography> */}
      </div>
      {/* <div className="flex items-center gap-1">
        <Typography variant="body3" className="text-auth-muted">
          {t('partner.revshare.income.table.costs')}:
        </Typography>
        <Typography variant="body3" className="text-dark font-medium">
          ${costs.toFixed(2)}
        </Typography>
      </div> */}
      {/* <div className="flex items-center gap-1">
        <Typography variant="body3" className="text-auth-muted">
          {t('partner.revshare.income.table.profit')}:
        </Typography>
        <Typography variant="body3" className="text-dark font-medium">
          ${profit.toFixed(2)}
        </Typography>
      </div> */}
    </div>
  );
};

export default EarningsCell;
